<template>
    <div class="copy-btn-wrapper" :class="{absolute: !isRelative}">
        <div class="anchor">
            <button
                @click="copyValueHandler"
                @mousedown="$emit('mouseDownHandler', value)"
                class="copy-btn"
                size="sm"
            >
                <img v-if="!showCopied" src="@/assets/images/copy.svg" alt="">
                <img v-if="showCopied" src="@/assets/images/copied.svg" alt="">
            </button>
            <div
                class="copy-btn-tooltip"
                :class="{right: tooltipPosition === 'right'}"
                v-if="showCopied"
            >Copied</div>
        </div>
    </div>
</template>

<script>
import VButton from "@/components/atoms/VButton";

export default {
    components: {VButton},
    data() {
        return {
            showCopied: false,
            actionTimeout: null,
        };
    },
    props: {
        value: String,
        isRelative: Boolean,
        tooltipPosition: String,
    },
    methods: {
        async copyValueHandler() {
            try {
                await navigator.clipboard.writeText(this.value);
                this.showCopied = true;

                if (this.actionTimeout) {
                    clearTimeout(this.actionTimeout);
                }

                this.actionTimeout = setTimeout(() => this.showCopied = false, 1500);
            } catch (err) {
                console.error('Failed to copy: ', err);
            }
        }
    },
}
</script>

<style scoped lang="scss">
.copy-btn-wrapper {
    display: inline-block;

    &.absolute {
        position: absolute;
        top: 15px;
        right: 15px;
    }

    .copy-btn {
        background-color: inherit;
        border: none;
        cursor: pointer;

        img {
            width: 16px;
            height: 16px;
        }

        &:hover {
            opacity: 0.8;
        }
    }

    .anchor {
        position: relative;
    }

    .copy-btn-tooltip {
        position: absolute;
        background: #fff;
        color: #686868;
        font-size: 14px;
        font-weight: 500;
        padding: 3px 5px;
        pointer-events: none;
        border-radius: 5px;
        left: -60px;
        top: -5px;

        &.right {
            left: 30px;
        }
    }
}
</style>